'use client';

import { Wizard } from '@/components/wizard/Wizard';

import { SubmitJobFlow } from './SubmitJobFlow';
import {
  defaultSubmitJobWizardState,
  type SubmitJobWizardState,
} from './submitJobWizardState';

interface SubmitJobWizardPanelProps {
  workspaceId: string;
  workspaceCloud: string;
  sparkEngineId: string;
  sparkEngineName: string;
  onAbort: () => void;
  onSubmitted: () => void;
}

export function SubmitJobWizardPanel({
  workspaceId,
  workspaceCloud,
  sparkEngineId,
  sparkEngineName,
  onAbort,
  onSubmitted,
}: SubmitJobWizardPanelProps) {
  return (
    <Wizard<SubmitJobWizardState>
      onAbort={onAbort}
      hideBackArrow={true}
      onFinish={async () => {
        onSubmitted();
        return true;
      }}
      flow={[SubmitJobFlow]}
      initialState={{
        ...defaultSubmitJobWizardState,
        workspaceId,
        workspaceCloud,
        sparkEngineId,
        sparkEngineName,
      }}
      title='Submit Job'
      stepperLabels={[]}
    />
  );
}
